// Import utility for conditional class names
import { cn } from '@/utilities/ui'
// Import React library
import React from 'react'
// Import rich text renderer
import RichText from '@/components/RichText'

// Import type for block props
import type { ContentBlock as ContentBlockProps } from '@/payload-types'

// Main block component
export const ContentBlock: React.FC<ContentBlockProps> = ({ richText }) => {
  return (
    <main className="container my-4" aria-label="Content">
      {richText && <RichText data={richText} enableGutter={false} enableProse={true} className="prose prose-headings:text-foreground prose-p:text-foreground" />}
    </main>
  )
}
